import { createFileRoute } from "@tanstack/react-router";
import { MasiniSitemapRedirect } from "@/components/layout/MasiniSitemapRedirect";

export const Route = createFileRoute("/sitemap.xml/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MasiniSitemapRedirect />
  );
}
